import { createFileRoute, redirect } from '@tanstack/react-router';
import { ContestEditLayout } from '../pages/contests/edit/contest-edit-layout';
import { isAuthenticated } from '../auth/session';

/**
 * The layout the four Edit steps hang off. It holds the shared header, the Setup
 * Rail and the form state; the step itself renders into its `<Outlet/>`.
 */
export const Route = createFileRoute('/contests/$id/edit')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' });
    }
  },
  component: function ContestEditRoute() {
    const { id } = Route.useParams();
    return <ContestEditLayout contestId={id} />;
  },
});
